import { TablePaginationConfig } from 'antd'
import { useState } from 'react'

export default function usePagination({
  current = 1,
  pageSize = 10,
  fetchCallback,
}: {
  current?: number
  pageSize?: number
  fetchCallback: (page: number, pageSize: number) => void
}) {
  const [pagination, setPagination] = useState({ current, pageSize })
  function onPaginationChange(page: number, pageSize: number) {
    setPagination({ current: page, pageSize })
    fetchCallback(page, pageSize)
  }
  return { pagination, onPaginationChange }
}
